import Header from "../header";
import Footer from "../footer";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { fetchLoansByAadhar } from "apiCalls/applyClaimService";
import { useLanguage } from "context/LanguageContext";

function ClaimLoaneeIdentification() {
    const navigate = useNavigate();
    const { t } = useLanguage();

    const [claimType, setClaimType] = useState("");
    const [loaneeAdharNumber, setLoaneeAdharNumber] = useState("");
    const [error, setError] = useState("");
    const [claimError, setClaimError] = useState("");
    const [loading, setLoading] = useState(false);

    function isValidAadhaar(value) {
        const digits = value.replace(/\s+/g, "");
        return /^\d{12}$/.test(digits);
    }

    async function handleFetchLoanee() {
        if (!claimType) {
            setClaimError(t.selectClaimTypeError);
            return;
        }
        setClaimError("");
        if (!loaneeAdharNumber.trim()) {
            setError(t.enterAadhaarError);
            return;
        }
        if (!isValidAadhaar(loaneeAdharNumber)) {
            setError(t.invalidAadhaarError);
            return;
        }
        setError("");
        setLoading(true);
        try {
            const res = await fetchLoansByAadhar(loaneeAdharNumber.trim())
            if (res.status !== "success") {
                setError(res.message || t.noLoansFound)
                return
            }
            navigate("/loanDetails", { state: { claimType, aadhaar: loaneeAdharNumber.trim(), loans: res.data } })
        } catch (err) {
            setError(err?.message || t.fetchLoanErrorRetry)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Header />

            {/* ==== Scroll up and progress start ==== */}
            <div id="scrollUp">
                <svg className="arrowup" viewBox="0 0 24 24" width="18" height="18">
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z" fill="#fff" />
                </svg>
                <svg className="scrollprogress" width="40" height="40">
                    <circle className="progress-circle" cx="20" cy="20" r="18" strokeWidth="2" fill="none" stroke="#fff" strokeDasharray="113.1" strokeDashoffset="113.1" />
                </svg>
            </div>
            {/* ==== Scroll up and progress Ends ==== */}

            {/* ==== Page Banner Section Start ==== */}
            <section className="rs-page-banner rs-faq-page-banner pt-30 pb-30 mt-140">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="rs-page-banner__content">
                                <h1 className="title">{t.applyNewClaim}</h1>
                                <p>{t.loaneeIdentPageSubtitle}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ==== Page Banner Section Ends ==== */}

            {/* ==== Page Section Start ==== */}
            <section className="rs-faq-page pt-50 pb-120">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">

                            {/* --1-- */}
                            <h5 className="mb-3">1. {t.selectClaimTypeLabel}</h5>
                            <div className="row">
                                <div className="col-md-6">
                                    <div
                                        className={`card card-claim text-center ${claimType === "disease" ? "active" : ""}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => { setClaimType("disease"); setClaimError(""); }}
                                    >
                                        <div className="mb-3"><i className="fa fa-wheelchair" style={{ fontSize: "2rem" }}></i></div>
                                        <h5>{t.diseaseClaimTitle}</h5>
                                        <p>{t.diseaseClaimCardDesc}</p>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div
                                        className={`card card-claim text-center ${claimType === "death" ? "active" : ""}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => { setClaimType("death"); setClaimError(""); }}
                                    >
                                        <div className="mb-3"><i className="fa fa-bed" style={{ fontSize: "2rem" }}></i></div>
                                        <h5>{t.deathClaimTitle}</h5>
                                        <p>{t.deathClaimCardDesc}</p>
                                    </div>
                                </div>
                            </div>
                            {claimError && <p className="text-danger mt-2" style={{ fontSize: "13px" }}>{claimError}</p>}
                            {/* --1-- */}

                            {/* --2-- */}
                            <h5 className="mt-5 mb-3">2. {t.loaneeIdentificationLabel}</h5>
                            <p>{t.loaneeIdentNote}</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group mt-3">
                                        <label className="form-label">{t.loaneeAadhaarNumber}</label>
                                        <input
                                            type="text"
                                            className={`form-control ${error ? "is-invalid" : ""}`}
                                            value={loaneeAdharNumber}
                                            onChange={e => { setLoaneeAdharNumber(e.target.value); setError(""); }}
                                            placeholder="xxxx xxxx xxxx"
                                            maxLength={12}
                                        />
                                        {error && <div className="invalid-feedback">{error}</div>}
                                    </div>
                                </div>
                            </div>
                            {/* --2-- */}

                            <div className="mt-4">
                                <button type="button" className="btn btn-primary" onClick={handleFetchLoanee} disabled={loading}>
                                    <i className="fa fa-search me-2"></i> {loading ? t.fetching : t.fetchLoans}
                                </button>
                            </div>
                             <div className="row mt-4">
                                <div className="col-md-12 text-end">
                                    <button className="btn btn-secondary me-3" onClick={() => navigate("/userDashboard")}><i className="fa fa-angle-left me-2"></i>{t.back}</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            {/* ==== Page Section Ends ==== */}

            <Footer />
        </>
    );
}

export default ClaimLoaneeIdentification;
